<template>
  <v-container v-if="law">
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs"/>
    </div>

    <div class="form-npa edit law-edit" v-if="fields">
      <div class="position">
        <div class="bg-white p-20">
          <form action="">
            <div class="form-head">
              <Widget position="menu_profile"/>
            </div>
            <ConfirmationDialog
              v-show="confirmationDialogShow"
              @click="confiramtionDialogClick"
              :title="$t('Вы хотите открыть закон для изменений?')"
            />
            <div class="form-body">
              <div class="top_buttons">
                <div class="status">
                  <span class="draft">
                    {{ $t('Статус') }}: {{ law.statusName }}
                  </span>
                </div>
                <div
                  class="switch"
                  v-if="disabledStatus && editable"
                >
                  <SwitchButton
                    :title="$t('Требуется принятие подзаконных актов')"
                    :switched="law.lawEnforcement"
                    @change="changeSwitch"
                  />
                </div>
                <div v-if="!editable && law.lawEnforcement" class="switch">
                  Требуется принятие подзаконных актов
                </div>
              </div>
              <div class="form-npa-basic">
                <div class="view-npa-body">
                  <div class="form-group">
                    <table class="table">
                      <tbody>
                      <tr>
                        <td>{{ $t("Наименование на государственном языке") }}</td>
                        <td>
                          <template v-if="!fields.nameKg.showEdit">
                            {{ law.nameKg }}
                          </template>
                          <template v-else-if="editable">
                            <InlineEdit
                              :params="fields.nameKg"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.nameKg.showEdit && editable"
                            @click="changeEditShow('nameKg')"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Наименование на официальном языке") }}</td>
                        <td>
                          <template v-if="!fields.name.showEdit">
                            {{ law.name }}
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.name"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.name.showEdit && editable"
                            @click="changeEditShow('name')"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Номер") }}</td>
                        <td>
                          <template v-if="!fields.number.showEdit">
                            {{ law.number }}
                          </template>
                          <template v-else-if="editable">
                            <InlineEdit
                              :params="fields.number"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.number.showEdit && editable"
                            @click="changeEditShow('number')"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Дата принятия") }}</td>
                        <td>
                          <template>
                            <v-menu
                              ref="menu"
                              v-model="fields.adoptionDate.menu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <a
                                  v-on="on"
                                  class="law_date"
                                >
                                  <span v-if="law.adoption_date">
                                    {{
                                    new Date(law.adoption_date)
                                    | dateFormat('DD.MM.YYYY')
                                    }}
                                  </span>
                                </a>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-if="fields && editable"
                                v-model="fields.adoptionDate.value"
                                no-title
                                :weekday-format="getDay"
                                :month-format="getMonthFormat"
                                :header-date-format="getHeaderDateFormat"
                                @change="updateAdoptionDate"
                              />
                            </v-menu>
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Дата вступления") }}</td>
                        <td>
                          <template>
                            <v-menu
                              ref="menu2"
                              v-model="fields.effectiveDate.menu2"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="290px"
                            >

                              <template v-slot:activator="{ on }">
                                <a
                                  class="law_date"
                                  v-on="on"
                                >
                                  <span v-if="law.effective_date">
                                    {{
                                    new Date(law.effective_date)
                                    | dateFormat('DD.MM.YYYY')
                                    }}
                                  </span>
                                </a>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-if="fields && editable"
                                v-model="fields.effectiveDate.value"
                                no-title
                                :weekday-format="getDay"
                                :month-format="getMonthFormat"
                                :header-date-format="getHeaderDateFormat"
                                @change="updateEffectiveDate"
                              />
                            </v-menu>
                          </template>
                        </td>
                      </tr>
                       <!------->
                       <tr v-if="isEnforecement">
                        <td>{{ $t("Статус в базе данных") }}</td>
                          <td>
                            <template v-if="!fields.status.showEdit">
                              {{ law.statusName }}
                              <span
                                class="change-status"
                                v-if="!disabledStatus && user.roleAdmin == true"
                                @click="changeStatus"
                              >
                                {{ $t('Открыть для операции') }}
                              </span>
                            </template>

                            <template v-else-if="editable">
                              <InlineEdit
                                :params="fields.status"
                                @update-field="update_field($event)"
                              />
                            </template>
                            <a
                              v-if="!fields.status.showEdit && editable"
                              @click="changeEditShow('status')"
                              class="edit-btn"
                            >
                              <span class="pro-icon-pencil"></span>
                            </a>
                          </td>
                      </tr>

                      <tr>
                        <td>{{ $t("Вид закона") }}</td>
                          <td>
                            <template v-if="!fields.kindOfLaw.showEdit">
                              {{ fields.kindOfLaw.fields[0].value }}
                            </template>
                            <template v-else-if="editable">
                              <InlineEdit
                                :params="fields.kindOfLaw"
                                @update-field="update_field($event)"
                              />
                            </template>
                            <a
                              v-if="!fields.kindOfLaw.showEdit && editable"
                              @click="changeEditShow('kindOfLaw')"
                              class="edit-btn"
                            >
                              <span class="pro-icon-pencil"></span>
                            </a>
                          </td>
                      </tr>
                      <!------->
                      <tr>
                        <td>{{ $t("Тип закона") }}</td>
                          <td>
                            <template v-if="!fields.lawType.showEdit">
                              {{ fields.lawType.fields[0].value }}
                            </template>
                            <template v-else-if="editable">
                              <InlineEdit
                                :params="fields.lawType"
                                @update-field="update_field($event)"
                              />
                            </template>
                            <a
                              v-if="!fields.lawType.showEdit && editable"
                              @click="changeEditShow('lawType')"
                              class="edit-btn"
                            >
                              <span class="pro-icon-pencil"></span>
                            </a>
                          </td>
                      </tr>
                       <!------->
                       <tr>
                        <td>{{ $t("Исполнение законов") }}</td>
                          <td>
                            <template v-if="!fields.executionOfLaw.showEdit">
                              {{ fields.executionOfLaw.fields[0].value }}
                            </template>
                            <template v-else-if="editable">
                              <InlineEdit
                                :params="fields.executionOfLaw"
                                @update-field="update_field($event)"
                              />
                            </template>
                            <a
                              v-if="!fields.executionOfLaw.showEdit && editable"
                              @click="changeEditShow('executionOfLaw')"
                              class="edit-btn"
                            >
                              <span class="pro-icon-pencil"></span>
                            </a>
                          </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Статус закона") }}</td>
                        <td>
                          <div class="link-npa-main" v-if="law.zbdStatus">
                            {{ law.zbdStatus.transName }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Ссылка на закон") }}</td>
                        <td>
                          <div class="link-cbd" v-if="law.zbdStatus">
                            <p>
                              <a target="_blank" :href="`https://cbd.minjust.gov.kg/${law.zbdCode}?kg`">
                                {{ $t("На гос.языке") }}
                              </a>
                            </p>
                            <p>
                              <a target="_blank" :href="`https://cbd.minjust.gov.kg/${law.zbdCode}?ru`">
                                {{ $t("На оф.языке") }}
                              </a>
                            </p>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <DocumentList
                      v-if="law"
                      :documents="law.lawDocuments"
                      @remove="removeLawDocument"
                    />

                    <FileInput
                      v-if="law.lawEnforcement && (this.user.roleAdmin || this.user.roleOperator) &&  this.editable"
                      v-model="files"
                      @save="saveDocument"
                    />
                  </div>
                </div>
                <!------>

                <div
                  class="form-group form-action"
                  v-if="disabledStatus"
                >
                  <template v-for="actionPermission in actionPermissions">
                    <v-btn
                      :key="actionPermission.id"
                      @click="action(actionPermission)"
                      :class="actionPermission.class"
                      rounded
                    >
                      {{ actionPermission.name }}
                    </v-btn>
                  </template>
                </div>
                <div v-if="lawsThatNormsRequiredChangesInLaw.length > 0">
                  <a href="#lawChange"><b>Внесение изменений в данный закон</b></a>
                </div>
                <!------>
                <div
                  class="create_norm"
                >
                  <div>
                    <div class="create_norm-title">
                      {{ $t('Исполнение законов') }}
                    </div>
                    <div v-if="permissionToAct && (user.roleAdmin || user.roleOperator)"
                      class="create_norm-button"
                      @click="sendCreateNorm"
                    >
                      {{ $t('Добавить норму') }}
                    </div>
                  </div>

                  <div
                    v-if="law.statusId == 5 && law.lawEnforcement && norms.length"
                    class="open_process-status"
                    @click="openProcessStatus"
                  >
                    Открыть для исполнителей
                  </div>
                </div>
                <!---norm---->
                <div>

                  <LawNormTable
                    :norms="norms"
                    :developers="refDevelopers"
                    @remove="removeNorm"
                    :permission-to-act="permissionToAct"
                  />
                </div>
                <div class="mt-4" v-if="lawsThatNormsRequiredChangesInLaw.length > 0" >
                  <div id="lawChange">
                    <h3>Нормы, которые требуют внесение изменений в данный закон</h3>
                  </div>
                  <table>
                    <template v-for="item in lawsThatNormsRequiredChangesInLaw">
                      <template v-if="item.executionOfLaw != 1 && item.norm.length > 0">
                        <tr :key="item.id">
                          <td :rowspan="item.norm.length">
                            {{ item.id }}
                          </td>
                          <td :rowspan="item.norm.length">
                            <template v-if="user">
                              <router-link
                                :title="item.transFullName | strippedContent"
                                :to="$i18nRoute({name: 'law-view', params: { id: item.id }})"
                              >
                                {{ item.transFullName }}
                              </router-link>
                            </template>
                            <template v-else>
                              {{ item.transFullName }}
                            </template>
                          </td>

                          <td :rowspan="item.norm.length">
                            {{  item.adoptionDate }}
                          </td>

                          <template v-if="item.norm.length > 0">
                            <td>
              <span v-if="item.norm.length > 0 && item.norm[0].article">
                Статья {{ item.norm[0].article.number }} <span v-if="item.norm[0].article_part">Ч.{{ item.norm[0].article_part }}</span>
              </span>

                              {{ item.norm[0].text }}
                              <span class="d-block mt-2" v-if="item.norm[0].law_changes_required && item.norm[0].law_to_change">
                <span class="d-block">Требует внесения изменений в закон:</span>
                <b>
                  <router-link
                    :to="$i18nRoute({name: 'law-view', params: { id: item.norm[0].law_to_change.id }})"
                  >
                    {{item.norm[0].law_to_change.transName}}
                  </router-link>
                </b>
              </span>
                            </td>
                            <td>
                              <div style="display:flex;flex-direction: column;"
                                   v-for="developer in item.norm[0].developers" :key="developer.id">
                                <div style="display: flex; align-items: center;">
                                  <span :class="{ 'font-weight-bold': developer.isMain }">{{ getDeveloperNameById(developer.id) }}</span>
                                  <img
                                    class="ml-1"
                                    v-if="item.norm[0].developers.length > 1 && developer.isMain"
                                    width="16"
                                    src="@/assets/icons/checked.png"
                                  />
                                </div>
                              </div>
                            </td>
                            <td>
              <span v-if="item.norm[0].implementationPeriod">
                {{ new Date(item.norm[0].implementationPeriod ) | dateFormat('DD.MM.YYYY') }}
              </span>
                            </td>
                            <td>
              <span v-if="item.norm[0].byLaw">
                {{ item.norm[0].byLaw.transName }}
              </span>
                              <span v-else>
                {{ $t('Нет') }}
              </span>
                            </td>
                            <td :rowspan="item.norm.length">
                              {{ item.allNorms }}
                            </td>
                            <td :rowspan="item.norm.length">
              <span v-if="item.ppkr > 0">
                {{ item.ppkr }}
              </span>
                            </td>
                            <td :rowspan="item.norm.length">
              <span v-if="item.prikazy > 0">
                {{ item.prikazy }}
              </span>
                            </td>
                            <td :rowspan="item.norm.length">
              <span v-if=" item.rpkr > 0">
                {{  item.rpkr }}
              </span>
                            </td>
                            <td :rowspan="item.norm.length">
              <span v-if="item.ukazy > 0">
                {{item.ukazy}}
              </span>
                            </td>
                            <td :rowspan="item.norm.length">
              <span v-if="item.notExecutedNorms > 0">
                {{ item.notExecutedNorms }}
              </span>
                            </td>
                          </template>
                        </tr>

                        <tr
                          v-for="normItem in item.norm.slice(1)"
                          :key="normItem.id"
                        >
                          <td>
              <span v-if="normItem.article">
                Статья {{ normItem.article.number }} <span v-if="normItem.article_part"> Ч.{{normItem.article_part}}</span>
              </span>
                            {{ normItem.text }}
                            <span class="d-block mt-2" v-if="normItem.law_changes_required && normItem.law_to_change">
                <span class="d-block">Требует внесения изменений в закон:</span>
                <b>
                  <router-link
                    :to="$i18nRoute({name: 'law-view', params: { id: normItem.law_to_change.id }})"
                  >
                    {{normItem.law_to_change.transName}}
                  </router-link>
                </b>
              </span>
                          </td>
                          <td>
                            <div style="display:flex;flex-direction: column;"
                                 v-for="developer in normItem.developers" :key="developer.id">
                              <div style="display: flex; align-items: center;">
                                <span :class="{ 'font-weight-bold': developer.isMain }">{{ getDeveloperNameById(developer.id) }}</span>
                                <img
                                  class="ml-1"
                                  v-if="normItem.developers.length > 1 && developer.isMain"
                                  width="16"
                                  src="@/assets/icons/checked.png"
                                />
                              </div>
                            </div>
                          </td>
                          <td>
              <span v-if="normItem.implementationPeriod">
                {{ new Date(normItem.implementationPeriod ) | dateFormat('DD.MM.YYYY') }}
              </span>
                          </td>
                          <td>
              <span v-if="normItem.byLaw">
                {{ normItem.byLaw.transName }}
              </span>
                            <span v-else>
                {{ $t('Нет') }}
              </span>
                          </td>
                        </tr>
                      </template>

                      <template v-else>
                        <tr :key="item.id">
                          <td>
                            {{ item.id }}
                          </td>
                          <td>
                            <template v-if="user">
                              <router-link
                                :title="item.transFullName | strippedContent"
                                :to="$i18nRoute({name: 'law-view', params: { id: item.id }})"
                              >
                                {{ item.transFullName }}
                              </router-link>
                            </template>
                            <template v-else>
                              {{ item.transFullName }}
                            </template>
                          </td>
                          <td>
                            {{  item.adoptionDate }}
                          </td>
                          <td colspan="10">
            <span v-if="item.isExecNorm && item.executionOfLaw.id != 1">
              {{ item.executionOfLaw.transName }}
            </span>
                          </td>
                        </tr>
                      </template>
                      <template v-if="item.firstDeveloper">
                        <tr v-for="firstDeveloperProject in item.firstDeveloper.projects" v-bind:key="item.id+item.firstDeveloper.id+firstDeveloperProject.id">
                          <td>
                            <template v-if="firstDeveloperProject.npaId">
                              <router-link
                                :title="firstDeveloperProject.transNpaName | strippedContent"
                                :to="$i18nRoute({name: 'view-npa', params: { id: firstDeveloperProject.npaId }})"
                                target="_blank"
                              >
                                {{ firstDeveloperProject.transNpaName }}
                              </router-link>
                            </template>
                            <template v-else>
                              {{ firstDeveloperProject.transNpaName }}
                            </template>
                          </td>
                          <td>
                            {{ firstDeveloperProject.stage }}
                            <v-menu
                              v-model="historiesMenu[firstDeveloperProject.id]"
                              :close-on-content-click="false"
                              :nudge-width="200"
                              offset-y
                              v-if="firstDeveloperProject.histories.length > 0"
                            >
                              <template v-slot:activator="{ on }">
                                <a v-on="on">{{ $t('История') }}</a>
                              </template>
                              <v-list dense class="history-list">
                                <v-list-item
                                  v-for="history in firstDeveloperProject.histories"
                                  :key="history.id"
                                  two-line
                                >
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      {{ history.stage }} {{ history.createdDate }}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </td>
                          <td>{{ firstDeveloperProject.note }}</td>
                        </tr>
                      </template>
                      <template v-for="developer in item.developers">
                        <tr v-bind:key="'dev_'+item.id+developer.id">
                          <td :rowspan="developer.rowSpanProject">
                            <template
                              v-if="
                user &&
                (user.roleAdmin === true || user.roleSpecialist || user.roleDeveloper) &&
                inProgressStatus &&
                item.statusId === inProgressStatus
              "
                            >
                              <router-link
                                :title="developer.developerTransName | strippedContent"
                                :to="$i18nRoute({name: 'solution-edit', params: { id: developer.id }})"
                              >
                                <v-icon
                                  v-if="developer.developerStatus === false"
                                  class="nv_icon mr-1"
                                  x-small
                                />
                                {{ developer.developerTransName }}
                              </router-link>
                            </template>
                            <template v-else>
                              <v-icon
                                v-if="developer.developerStatus === false"
                                class="nv_icon mr-1"
                                x-small
                              />
                              {{ developer.developerTransName }}
                            </template>
                          </td>
                          <td :rowspan="developer.rowSpanProject">
                            {{ developer.solveNeeded ? $t("Требуется") : $t("Не требуется") }}
                          </td>
                          <template v-if="developer.firstProject">
                            <td>
                              <template v-if="developer.firstProject.npaId">
                                <router-link
                                  :title="developer.firstProject.transNpaName | strippedContent"
                                  :to="$i18nRoute({name: 'view-npa', params: { id: developer.firstProject.npaId }})"
                                  target="_blank"
                                >
                                  {{ developer.firstProject.transNpaName }}
                                </router-link>
                              </template>
                              <template v-else>
                                {{ developer.firstProject.transNpaName }}
                              </template>
                            </td>
                            <td>
                              {{ developer.firstProject.stage }}
                              <v-menu
                                v-model="historiesMenu[developer.firstProject.id]"
                                :close-on-content-click="false"
                                :nudge-width="200"
                                offset-y
                                v-if="developer.firstProject.histories.length > 0"
                              >
                                <template v-slot:activator="{ on }">
                                  <a v-on="on">{{ $t('История') }}</a>
                                </template>
                                <v-list dense class="history-list">
                                  <v-list-item
                                    v-for="history in developer.firstProject.histories"
                                    :key="history.id"
                                    two-line
                                  >
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        {{ history.stage }} {{ history.createdDate }}
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </td>
                            <td>{{ developer.firstProject.note }}</td>
                          </template>
                          <template v-else>
                            <td></td>
                            <td></td>
                            <td></td>
                          </template>
                        </tr>
                        <template v-if="developer.projects">
                          <tr v-for="developerProject in developer.projects" v-bind:key="item.id+developer.id+developerProject.id">
                            <td>
                              <template v-if="developerProject.npaId">
                                <router-link
                                  :title="developerProject.transNpaName | strippedContent"
                                  :to="$i18nRoute({name: 'view-npa', params: { id: developerProject.npaId }})"
                                  target="_blank"
                                >
                                  {{ developerProject.transNpaName }}
                                </router-link>
                              </template>
                              <template v-else>
                                {{ developerProject.transNpaName }}
                              </template>
                            </td>
                            <td>
                              {{ developerProject.stage }}
                              <v-menu
                                v-model="historiesMenu[developerProject.id]"
                                :close-on-content-click="false"
                                :nudge-width="200"
                                offset-y
                                v-if="developerProject.histories.length > 0"
                              >
                                <template v-slot:activator="{ on }">
                                  <a v-on="on">{{ $t('История') }}</a>
                                </template>
                                <v-list dense class="history-list">
                                  <v-list-item
                                    v-for="history in developerProject.histories"
                                    :key="history.id"
                                    two-line
                                  >
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        {{ history.stage }} {{ history.createdDate }}
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </td>
                            <td>{{ developerProject.note }}</td>
                          </tr>
                        </template>
                      </template>
                    </template>
                  </table>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import LAW from '@/model/law'
  import Widget from '@/components/app/Widget'
  import InlineEdit from '@/components/law/InlineEdit'
  import LawNormTable from '@/components/law/LawNormTable'
  import { mapGetters, mapMutations } from 'vuex'
  import moment from 'moment'
  import User from '@/model/user'
  import mixin from '@/plugins/mixin/mixin'
  import {Trans} from "@/plugins/Translation"
  import SwitchButton from '@/components/widget/SwitchButton.vue'
  import ConfirmationDialog from '@/components/widget/ConfirmationDialog.vue'
  import FileInput from '@/components/widget/FileInput.vue'
  import DocumentList from '@/components/widget/DocumentList.vue'

  export default {
    mixins: [mixin],
    props: {
      viewName: {
        type: String,
        default: ''
      }
    },
    components: {
      Widget,
      InlineEdit,
      LawNormTable,
      SwitchButton,
      ConfirmationDialog,
      FileInput,
      DocumentList
    },
    data() {
      return {
        confirmationDialogShow: false,
        byLawsRequired: false,
        editDisableStatuses: [4],
        law: null,
        lawsThatNormsRequiredChangesInLaw: null,
        norms: [],
        lawData: {},
        breadcrumbs: [],
        fields1: null,
        editable: false,
        actionPermissions: null,
        developers: [],
        refDevelopers: [],
        files: [],
      }
    },
    watch: {
      // при изменениях маршрута запрашиваем данные снова
      $route: 'fetchData'
    },
    computed: {
      showFileInput () {
        let ids = [1,3]
        return ids.includes(this.user.id) && this.editable
      },
      ...mapGetters({
        searchData: 'getSearchData'
      }),
      user() {
        return this.$store.state.getNpaData.currentUser
      },
      permissionToAct() {
        if (this.law.statusId == null) {
          return
        }

        return this.disabledStatus && this.law.lawEnforcement
      },

      disabledStatus () {
        return !this.editDisableStatuses.includes(this.law.statusId)
      },

      isEnforecement() {
        return this.viewName != 'viewName'
      },
      currentLocaleUrl () {
        return Trans.currentLocaleUrl
      },
      fields () {
        return {
          name: {
            name: 'name',
            showEdit: false,
            fields: [
              {
                name: 'name',
                label: this.$i18n.t('Наименование на официальном языке'),
                value: this.law?.name,
                type: 'varchar'
              }
            ]
          },
          nameKg: {
            name: 'nameKg',
            showEdit: false,
            fields: [
              {
                name: 'nameKg',
                label: this.$i18n.t('Наименование на государственном языке'),
                value: this.law?.nameKg,
                type: 'varchar'
              }
            ]
          },
          number: {
            name: 'number',
            showEdit: false,
            fields: [
              {
                name: 'number',
                label: this.$i18n.t('Номер'),
                value: this.law?.number,
                type: 'varchar'
              }
            ]
          },
          kindOfLaw: {
            name: 'kindOfLaw',
            showEdit: false,
            fields: [
              {
                name: 'kindOfLaw',
                label: this.$i18n.t('Вид закона'),
                value: this.law?.kindOfLaw?.transName,
                type: 'references',
                referencesData: this.lawData.refKindOfLaw
              }
            ]
          },
          lawType: {
            name: 'lawType',
            showEdit: false,
            fields: [
              {
                name: 'lawType',
                label: this.$i18n.t('Тип закона'),
                value: this.law.lawType?.transName,
                type: 'references',
                referencesData: this.lawData.refLawType
              }
            ]
          },
          status: {
            name: 'status',
            showEdit: false,
            fields: [
              {
                name: 'status',
                label: this.$i18n.t('Статус в базе данных'),
                value: this.law?.statusName,
                type: 'references',
                referencesData: this.lawData.refLawStatus
              }
            ]
          },
          executionOfLaw: {
            name: 'executionOfLaw',
            showEdit: false,
            fields: [
              {
                name: 'executionOfLaw',
                label: this.$i18n.t('Исполнение законов'),
                value: this.law.executionOfLaw?.transName,
                type: 'references',
                referencesData: this.lawData.refExecutionOfLaw
              }
            ]
          },
          adoptionDate: {
            menu: false,
            value: moment(this.law.adoptionDate).format(
              'YYYY-MM-DD'
            )
          },
          effectiveDate: {
            menu: false,
            value: moment(this.law.effectiveDate).format(
              'YYYY-MM-DD'
            )
          }
        }
      }
    },
    mounted() {
      // загружаем данные, когда представление создано
      // и данные реактивно отслеживаются
      this.fetchData()
      this.scrollToTop()
    },
    methods: {
      ...mapMutations(['setLoading']),
      openProcessStatus () {
        this.setLoading(true)
        LAW.updateLaw({ status: 2 }, this.$route.params.id).then((response) => {
          this.fetchData()
        })
      },

      removeLawDocument (documentId) {
        LAW.removeLawDocument(this.law.id, documentId).then(() =>{
          LAW.getLaw(this.$route.params.id).then((response) => {
            this.law = response.data.law
          })
        })
      },

      saveDocument (form) {
        let fd = new FormData()

        fd.append(`law_document_type[uploadedFile]`, form.file)
        fd.append(`law_document_type[description]`, form.description)
        this.setLoading(true)
        LAW.addLawDocument(this.law.id, fd).then(() => {
          LAW.getLaw(this.$route.params.id).then((response) => {
            this.law = response.data.law
            this.setLoading(false)
          }).catch(() => {
            this.setLoading(false)
          }).catch(() => {
            this.setLoading(false)
          })
        })
      },


      confiramtionDialogClick (type) {
        this.confirmationDialogShow = !this.confirmationDialogShow

        if (type) {
          LAW.updateLaw({ status: 3 }, this.$route.params.id).then((response) => {
            this.update_field({
              status: true,
              fieldName: 'status',
              law: response.data
            })

            this.$nextTick(() => { this.$router.go(0)})
          }).catch(() => {})
        }
      },

      changeStatus () {
        this.confirmationDialogShow = !this.confirmationDialogShow
      },

      changeSwitch () {
        if (this.norms.length > 0 && this.law.lawEnforcement  == true) {
          alert('Сначала удалите все нормы')
          return false
        }

        this.setLoading(true)
        LAW.updateLaw({ lawEnforcement: !this.law.lawEnforcement }, this.law.id).then(() =>{
          this.law.lawEnforcement = !this.law.lawEnforcement
          this.setLoading(false)
        })
      },

      changeEditShow (value) {
        this.fields[value].showEdit = true
        this.$forceUpdate()
      },

      removeNorm (id) {
        console.log(id)
        this.norms = this.norms.filter(item => item.id != id)
      },

      sendCreateNorm() {
        this.$router.push({
          name: 'create-norm',
          params: {
            id: this.law.id
          }
        })
      },
      // подгрузка данных
      fetchData() {
        this.setLoading(true)
        LAW.getLaw(this.$route.params.id).then((response) => {
          this.law = response.data.law
          this.norms = response.data.norms
          this.lawsThatNormsRequiredChangesInLaw = response.data.lawsThatNormsRequiredChangesInLaw
          this.developers = response.data.developers
          this.refDevelopers = response.data.refDevelopers
          this.setLoading(false)
          this.fetchLawData()
          this.generateBreadcrumbs(this.law.transName)
          this.getActionPermissions(this.law.statusId)
        }).catch((error) => {
          if(error.response.status != null) {
          this.$router.push(Trans.i18nRoute({
            name: 'error',
            params: {
              status: error.response.status
            }
          }))
          }
          this.setLoading(false)
        })
      },

      fetchLawData () {
        LAW.getLawData()
          .then((response) => {
            this.lawData = response.data

            this.initFields()
            this.setLoading(false)
          })
          .catch((error) => {

          })
      },
      // генерация хлебных крошек
      generateBreadcrumbs(name) {
        this.breadcrumbs = [
          {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
          {text: this.$i18n.t('Исполнение законов'), disabled: false, href: Trans.currentLocaleUrl + '/law'},
          {text: name, disabled: true}
        ]
      },
      //
      initFields() {
        this.lawData.refExecutionOfLaw.push({
          id: null,
          transName: ''
        })
        this.fields = {
          name: {
            name: 'name',
            showEdit: false,
            fields: [
              {
                name: 'name',
                label: this.$i18n.t('Наименование на официальном языке'),
                value: this.law.name,
                type: 'varchar'
              }
            ]
          },
          nameKg: {
            name: 'nameKg',
            showEdit: false,
            fields: [
              {
                name: 'nameKg',
                label: this.$i18n.t('Наименование на государственном языке'),
                value: this.law.nameKg,
                type: 'varchar'
              }
            ]
          },
          number: {
            name: 'number',
            showEdit: false,
            fields: [
              {
                name: 'number',
                label: this.$i18n.t('Номер'),
                value: this.law.number,
                type: 'varchar'
              }
            ]
          },
          kindOfLaw: {
            name: 'kindOfLaw',
            showEdit: false,
            fields: [
              {
                name: 'kindOfLaw',
                label: this.$i18n.t('Вид закона'),
                value: this.law.kindOfLaw?.transName,
                type: 'references',
                referencesData: this.lawData.refKindOfLaw
              }
            ]
          },
          lawType: {
            name: 'lawType',
            showEdit: false,
            fields: [
              {
                name: 'lawType',
                label: this.$i18n.t('Тип закона'),
                value: this.law.lawType?.transName,
                type: 'references',
                referencesData: this.lawData.refLawType
              }
            ]
          },
          status: {
            name: 'status',
            showEdit: false,
            fields: [
              {
                name: 'status',
                label: this.$i18n.t('Статус в базе данных'),
                value: this.law.statusName,
                type: 'references',
                referencesData: this.lawData.refLawStatus
              }
            ]
          },
          executionOfLaw: {
            name: 'executionOfLaw',
            showEdit: false,
            fields: [
              {
                name: 'executionOfLaw',
                label: this.$i18n.t('Исполнение законов'),
                value: this.law.executionOfLaw?.transName,
                type: 'references',
                referencesData: this.lawData.refExecutionOfLaw
              }
            ]
          },
          adoptionDate: {
            menu: false,
            value: moment(this.law.adoptionDate).format(
              'YYYY-MM-DD'
            )
          },
          effectiveDate: {
            menu: false,
            value: moment(this.law.effectiveDate).format(
              'YYYY-MM-DD'
            )
          }
        }
      },
      // изменение полей
      update_field(result) {
        if (result.law) {
          LAW.getLaw(result.law.law).then((response) => {
            this.setLoading(true)
            this.law = response.data.law
            this.generateBreadcrumbs(this.law.transName)
            this.setLoading(false)
          })
        }
        this.fields[result.fieldName].showEdit = false
        this.$forceUpdate()
      },
      // изменение даты принятия
      updateAdoptionDate(date) {
        this.law.adoptionDate = date
        this.$refs.menu.save(date)
        LAW.updateLaw({adoptionDate: date}, this.law.id).then((response) => {
          let result = response.data
          LAW.getLaw(result.law).then((response) => {
            this.setLoading(true)
            this.law = response.data.law
            this.initFields()
            this.setLoading(false)
          })
        })
      },
      // изменение Даты вступления в силу
      updateEffectiveDate(date) {
        this.law.effectiveDate = date
        this.$refs.menu2.save(date)
        LAW.updateLaw({effectiveDate: date}, this.law.id).then(
          (response) => {
            let result = response.data
            LAW.getLaw(result.law).then((response) => {
              this.setLoading(true)
              this.law = response.data.law
              this.initFields()
              this.setLoading(false)
            })
          }
        )
      },
      // список действий
      getActionPermissions(statusId) {
        User.getActionPermissionsLaw(statusId).then((response) => {
          this.actionPermissions = response.data
        })
      },
      // действия
      action(actionPermission) {
        if (actionPermission.type == 'law_edit') {
          this.editable = true
          return
        }
        if (actionPermission.type == 'law_cancel') {
          this.editable = false
          return
        }
        if (actionPermission.type == 'law_status') {
            LAW.updateStatus(this.law.id, {stageId: actionPermission.id})
              .then((response) => {
                this.law.statusId = response.data.statusId
                this.law.statusName = response.data.statusName
                this.getActionPermissions(this.law.statusId)
              })
              .catch((error) => {
                console.log(error)
                this.$noty.warning(this.$i18n.t('Ошибка'), {
                  killer: true,
                  timeout: 1000,
                  layout: 'topRight'
                })
              })
          this.editable = false

          return
        }
      },
      // Прокручивание к началу страницы
      scrollToTop() {
        window.scrollTo(0, 0)
      },
      getDeveloperNameById (id) {
        let developer = this.searchData.refDeveloper.find(item => item.id == id)
        return developer != null ? developer.transName : ''
      },
    }
  }
</script>
<style lang="scss" scoped>
  .create_norm {
    display: flex;
    align-items: center;

    &-title {
      font-weight: 500;
    }

    &-button {
      margin-left: 10px;
      background-color: #004484;
      padding: 5px 15px;
      color: #fff;
      cursor:pointer;
      margin-right: 100px;
    }
  }

  .law_date {
    text-decoration: none;
    color: #000 !important;
  }

  .link-cbd {
    display: flex;
    flex-direction: column;
  }

  .top_buttons {
    display: flex;

    .switch {
      margin-left: 60px;
    }
  }

  .change-status {
    text-decoration: underline;
    margin-left: 40px;
    cursor: pointer;
  }

  .open_process-status {
    background: #d5a154;
    padding: 5px 30px;
    color: #fff;
    font-weight: 600;
    cursor: pointer;
  }
</style>
